import { State } from 'common/interfaces/state';
import { SubscriptionActivityStatus } from 'unit-subscription/enums/subscription-activity-status';
import { SubscriptionStatus } from 'unit-subscription/enums/subscription-status';
import { RegexTemplates } from '../../constants';
import { Company } from './interfaces/company';
import { CompanySubscriptionModel } from './interfaces/company-subscription-model';

function getCompanySubscription(s: State, company: Company): CompanySubscriptionModel {
  const selectedSubscriptionType = s.account.selectedSubscriptionType;
  return company && company.subscriptions && company.subscriptions[selectedSubscriptionType];
}

function getPaidEmployeesCount(s: State): number {
  const users = s.people.companiesUsers;
  return (users && users.filter(x => x.isPayable).length) || 0;
}

function getGuestUsersCount(s: State): number {
  const users = s.people.companiesUsers;
  return (
    (users &&
      users.filter(
        x => !x.isPayable && x.email && !RegexTemplates.KREO_EMAIL.test(x.email.toLowerCase()),
      ).length) ||
    0
  );
}

function isOwnCompanyLicensesLimitExceeded(s: State): boolean {
  const ownedCompany = s.account.ownedCompany;

  if (!ownedCompany) {
    return false;
  }

  const ownCompany = s.account.companies.find(c => c.id === ownedCompany.id);
  const subscription = getCompanySubscription(s, ownCompany);
  const paidEmployeesCount = getPaidEmployeesCount(s);

  return subscription && paidEmployeesCount > subscription.employeesMaxCount;
}

function isSelectedCompanyLicensesLimitExceeded(s: State): boolean {
  const subscription = currentSubscription(s);
  const paidEmployeesCount = getPaidEmployeesCount(s);

  return subscription && paidEmployeesCount > subscription.employeesMaxCount;
}

function currentSubscription(s: State): CompanySubscriptionModel {
  const selectedCompany = s.account.selectedCompany;
  return getCompanySubscription(s, selectedCompany);
}

function isFreeSubscription(subscription: CompanySubscriptionModel): boolean {
  return subscription && subscription.billingStatus === SubscriptionActivityStatus.NonRenewing;
}

function hasSelectedCompanyActiveSubscription(s: State): boolean {
  const subscription = currentSubscription(s);
  return subscription?.status === SubscriptionStatus.Valid;
}

export const AccountSelectors = {
  hasSelectedCompanyActiveSubscription,
  isOwnCompanyLicensesLimitExceeded,
  isFreeSubscription,
  isSelectedCompanyLicensesLimitExceeded,
  currentSubscription,
  getPaidEmployeesCount,
  getGuestUsersCount,
};
